import React, { Component } from 'react'
import '../styles/GiftCard.css'
import Navbar from './Navbar'
import { Helmet } from 'react-helmet'
import Footer from './Footer'
import { withRouter } from 'react-router-dom'
import { injectIntl } from 'react-intl'
import { webURL } from '../webURL'

const cover = {
  backgroundImage: "url(../static/media/coverbasic.png)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center"
}

const contentStyle = {
  position: "relative"
}

const containerStyle = {
  height: "auto"
}

class NotFound extends Component {

  render() {

    return (
     <div className="gift-card">
      <Helmet>
        <title>Erreur 404 :(</title>
      </Helmet>
      <Navbar
        lang={this.props.lang}
        handleLang={(lang) => this.props.handleLang(lang)} />
      <div className="gift-card-cover" style={cover}>
        <div className="tb-hero-title"><h1>Erreur 404</h1><p>(quand on s'est perdu)</p></div>
      </div>

      <div style={containerStyle}>
        <div style={contentStyle}>
          <div className="gift-card-content-text">
            Vous êtes perdu ? Voici quelques rubriques qui pourraient vous intéresser :
              <ul className="not-found-list">
								<li><a href={`${webURL}`}>Accueil</a></li>
								<li><a href={`${webURL}faq`}>Vous avez des questions ?</a></li>
								<li><a href={`${webURL}contact`}>Nous contacter</a></li>
								<li><a href={`${webURL}mentions-legales/`}>Mentions légales</a></li>
								<li><a href={`${webURL}presse/`}>Presse escape game</a></li>
								<li><a href="https://escape-game-paris.one-hour.fr/">Blog escape game</a></li>
								<li><a href={`${webURL}conditions-generales-de-vente/`}>CGV</a></li>
								<li><a href={`${webURL}escape-game-paris-11/`}>Escape game Paris 11</a></li>
								<li><a href={`${webURL}escape-game-horreur/`}>Escape game horreur</a></li>
								<li><a href={`${webURL}escape-game-festif`}>Escape game festif</a></li>
								<li><a href={`${webURL}enterrement-de-vie-de-garcon-escape-game/`}>Enterrement vie de garçon escape game</a></li>
								<li><a href={`${webURL}enterrement-de-vie-de-jeune-fille-escape-game/`}>Enterrement vie de jeune fille escape game</a></li>
								<li><a href={`${webURL}escape-game-anniversaire/`}>Anniversaire escape game</a></li>
								<li><a href={`${webURL}sortie-originale-a-paris`}>Sortie originale à Paris</a></li>
								<li><a href={`${webURL}carte-cadeaux`}>Cadeau escape game</a></li>
								<li><a href={`${webURL}escape-game-deux-joueurs/`}>Escape game deux joueurs</a></li>
								<li><a href={`${webURL}escape-game-voltaire/`}>Escape game Voltaire</a></li>
								<li><a href={`${webURL}credits/`}>Crédits</a></li>
								<li><a href={`${webURL}live-escape-game-paris/`}>Live Escape game paris</a></li>
              </ul>
          </div>
        </div>
      </div>
      <Footer />
     </div>
    )
  }
}

export default withRouter(injectIntl(NotFound))



// WEBPACK FOOTER //
// ./src/components/NotFound.js